import { Route, Navigate } from "react-router-dom";
import { lazy, Suspense, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Customers from "../../components/Customers/Customers";
import { FullPageComponentLoader } from "../../common/components/FullPageComponentLoader/FullPageComponentLoader";
const CustomerList = lazy(() => import("../../components/Customers/CustomerList/CustomerList"));
const OrderHistory = lazy(() => import("../../components/Customers/OrderHistory/OrderHistory"));

export enum CUSTOMER_ROUTES {
  BASE_PATH = "/customer/",
  OVERVIEW = `overview`,
  LIST = `list`,
  ORDER = `order`,
}

export const CUSTOMER_ROUTE_PATHS = [CUSTOMER_ROUTES.LIST, CUSTOMER_ROUTES.ORDER].map(
  (route) => `${CUSTOMER_ROUTES.BASE_PATH}${route}`,
);

const OverviewRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(`${CUSTOMER_ROUTES.BASE_PATH}${CUSTOMER_ROUTES.LIST}`, { replace: true });
  }, [navigate]);

  return <FullPageComponentLoader />;
};

export const CustomersRoutes = () => {
  return (
    <Route
      path={CUSTOMER_ROUTES.BASE_PATH}
      element={
        <Suspense fallback={<FullPageComponentLoader />}>
          <Customers />
        </Suspense>
      }
    >
      <Route path={CUSTOMER_ROUTES.LIST} element={<CustomerList />} />
      <Route path={CUSTOMER_ROUTES.ORDER} element={<OrderHistory />} />
      <Route path={CUSTOMER_ROUTES.OVERVIEW} element={<OverviewRedirect />} />
      <Route index element={<Navigate to={CUSTOMER_ROUTES.LIST} />} />
    </Route>
  );
};
